import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="text-start container mt-3">
      <div className="WordSection1">
        <p className="MsoNormal">
          <b>
            PRIVACY POLICY<div></div>
          </b>
        </p>

        <p className="MsoNormal">
          <b>Last updated&nbsp;April 25, 2025</b>
          <div></div>
        </p>

        <p className="MsoNormal">
          This Privacy Notice for&nbsp;New Life Financial Services
          Ltd.&nbsp;(&quot;<b>we</b>,&quot; &quot;<b>us</b>,&quot; or &quot;
          <b>our</b>&quot;), describes how and why we might access, collect,
          store, use, and/or share (&quot;<b>process</b>&quot;) your personal
          information when you use our services (&quot;<b>Services</b>&quot;),
          including when you:<div></div>
        </p>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            Visit our website&nbsp;at&nbsp;
            <a href="http://www.newlifefinancialservices.ca/" target="_blank">
              http://www.newlifefinancialservices.ca
            </a>
            , or any website of ours that links to this Privacy Notice
            <div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            Use&nbsp;Life Insurance, <span className="SpellE">SuperVisa</span>,
            Critical Illness insurance, Disability insurance, visitor Insurance,
            RESP, RRSP, Visitor Insurance.&nbsp;__________<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            Engage with us in other related ways, including any sales,
            marketing, or events<div></div>
          </li>
        </ul>

        <p className="MsoNormal">
          <b>Questions or concerns?&nbsp;</b>Reading this Privacy Notice will
          help you understand your privacy rights and choices. We are
          responsible for making decisions about how your personal information
          is processed. If you do not agree with our policies and practices,
          please do not use our Services.&nbsp;If you still have any questions
          or concerns, please contact us
          at&nbsp;admin@newlifefinancialservices.ca.<div></div>
        </p>

        <p className="MsoNormal">
          <div>&nbsp;</div>
        </p>

        <p className="MsoNormal">
          <b>
            SUMMARY OF KEY POINTS<div></div>
          </b>
        </p>

        <p className="MsoNormal">
          <b>
            <i>
              This summary provides key points from our Privacy Notice, but you
              can find out more details about any of these topics by clicking
              the link following each key point or by using our&nbsp; table of
              contents below to find the section you are looking for.
            </i>
          </b>
          <div></div>
        </p>

        <p className="MsoNormal">
          <b>What personal information do we process?</b>&nbsp;When you visit,
          use, or navigate our Services, we may process personal information
          depending on how you interact with us and the Services, the choices
          you make, and the products and features you use. Learn more
          about&nbsp; personal information you disclose to us .<div></div>
        </p>

        <p className="MsoNormal">
          <b>Do we process any sensitive personal information?&nbsp;</b>Some of
          the information may be considered&nbsp;&quot;special&quot; or
          &quot;sensitive&quot;&nbsp;in certain jurisdictions, for example your
          racial or ethnic origins, sexual orientation, and religious
          beliefs.&nbsp;We may process sensitive personal information when{" "}
          <span className="GramE">necessary</span> with your consent or as
          otherwise permitted by applicable law. Learn more about&nbsp;
          sensitive information we process .<div></div>
        </p>

        <p className="MsoNormal">
          <b>Do we collect any information from third parties?</b>&nbsp;We do
          not collect any information from third parties.<div></div>
        </p>

        <p className="MsoNormal">
          <b>How do we process your information?</b>&nbsp;We process your
          information to provide, improve, and administer our Services,
          communicate with you, for security and fraud prevention, and to comply
          with law. We may also process your information for other purposes with
          your consent. We process your information only when we have a valid
          legal reason to do so. Learn more about&nbsp; how we process your
          information .<div></div>
        </p>

        <p className="MsoNormal">
          <b>
            In what situations and with which&nbsp;parties do we share personal
            information?
          </b>
          &nbsp;We may share information in specific situations and with
          specific&nbsp;third parties. Learn more about&nbsp; when and with whom
          we share your personal information .<div></div>
        </p>

        <p className="MsoNormal">
          <b>How do we keep your information safe?</b>&nbsp;We have
          adequate&nbsp;organizational&nbsp;and technical processes and
          procedures in place to protect your personal information. However, no
          electronic transmission over the internet or information storage
          technology can be guaranteed to be 100% secure, so we cannot promise
          or guarantee that hackers, cybercriminals, or
          other&nbsp;unauthorized&nbsp;third parties will not be able to defeat
          our security and improperly collect, access, steal, or modify your
          information. Learn more about&nbsp; how we keep your information safe
          .<div></div>
        </p>

        <p className="MsoNormal">
          <b>What are your rights?</b>&nbsp;Depending on where you are located
          geographically, the applicable privacy law may mean you have certain
          rights regarding your personal information. Learn more about&nbsp;
          your privacy rights .<div></div>
        </p>

        <p className="MsoNormal">
          <b>How do you exercise your rights?</b>&nbsp;The easiest way to
          exercise your rights is by&nbsp;submitting a&nbsp; data subject access
          request , or by contacting us. We will consider and act upon any
          request in accordance with applicable data protection laws.<div></div>
        </p>

        <p className="MsoNormal">
          Want to learn more about what we do with any information we
          collect?&nbsp; Review the Privacy Notice in full .<div></div>
        </p>

        <p className="MsoNormal">
          <div>&nbsp;</div>
        </p>

        <p className="MsoNormal">
          <b>
            TABLE OF CONTENTS<div></div>
          </b>
        </p>

        <p className="MsoNormal">
          1. WHAT INFORMATION DO WE COLLECT?
          <div></div>
        </p>

        <p className="MsoNormal">
          2. HOW DO WE PROCESS YOUR INFORMATION?
          <div></div>
        </p>

        <p className="MsoNormal">
          3.&nbsp;WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR PERSONAL
          INFORMATION?
          <div></div>
        </p>

        <p className="MsoNormal">
          4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
          <div></div>
        </p>

        <p className="MsoNormal">
          5. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
          <div></div>
        </p>

        <p className="MsoNormal">
          6. HOW DO WE HANDLE YOUR SOCIAL LOGINS?
          <div></div>
        </p>

        <p className="MsoNormal">
          7. HOW LONG DO WE KEEP YOUR INFORMATION?
          <div></div>
        </p>

        <p className="MsoNormal">
          8. HOW DO WE KEEP YOUR INFORMATION SAFE?
          <div></div>
        </p>

        <p className="MsoNormal">
          9. WHAT ARE YOUR PRIVACY RIGHTS?
          <div></div>
        </p>

        <p className="MsoNormal">
          10. CONTROLS FOR DO-NOT-TRACK FEATURES
          <div></div>
        </p>

        <p className="MsoNormal">
          11. DO WE MAKE UPDATES TO THIS NOTICE?
          <div></div>
        </p>

        <p className="MsoNormal">
          12. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
          <div></div>
        </p>

        <p className="MsoNormal">
          13. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM
          YOU?
          <div></div>
        </p>

        <p className="MsoNormal">
          <div>&nbsp;</div>
        </p>

        <p className="MsoNormal">
          <b>
            1. WHAT INFORMATION DO WE COLLECT?<div></div>
          </b>
        </p>

        <p className="MsoNormal">
          <b>
            Personal information you disclose to us<div></div>
          </b>
        </p>

        <p className="MsoNormal">
          <b>
            <i>In Short:&nbsp;</i>
          </b>
          <i>We collect personal information that you provide to us.</i>
          <div></div>
        </p>

        <p className="MsoNormal">
          We collect personal information that you voluntarily provide to us
          when you&nbsp;register on the Services,&nbsp;express an interest in
          obtaining information about us or our products and Services, when you
          participate in activities on the Services, or otherwise when you
          contact us.
          <div></div>
        </p>

        <p className="MsoNormal">
          <b>Personal Information Provided by You.</b>&nbsp;The personal
          information that we collect depends on the context of your
          interactions with us and the Services, the choices you make, and the
          products and features you use. The personal information we collect may
          include the following:<div></div>
        </p>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            names<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            phone numbers<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            email addresses<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            mailing addresses<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            contact preferences<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            billing addresses<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            date of birth<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            date of birth<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            gender<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            assets and liabilities<div></div>
          </li>
        </ul>

        <p className="MsoNormal">
          <b>Sensitive Information.</b>&nbsp;When necessary, with your consent
          or as otherwise permitted by applicable law, we process the following
          categories of sensitive information:<div></div>
        </p>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            financial data<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            health data<div></div>
          </li>
        </ul>

        <p className="MsoNormal">
          <b>Social Media Login Data.&nbsp;</b>We may provide you with the
          option to register with us using your existing social media account
          details, like your Facebook, X, or other social media account. If you
          choose to register in this way, we will collect certain profile
          information about you from the social media provider, as described in
          the section called&nbsp;&quot; HOW DO WE HANDLE YOUR SOCIAL LOGINS?
          &quot;&nbsp;below.<div></div>
        </p>

        <p className="MsoNormal">
          All personal information that you provide to us must be true,
          complete, and accurate, and you must notify us of any changes to such
          personal information.<div></div>
        </p>

        <p className="MsoNormal">
          <b>
            Information automatically collected<div></div>
          </b>
        </p>

        <p className="MsoNormal">
          <b>
            <i>In Short:&nbsp;</i>
          </b>
          <i>
            Some information — such as your Internet Protocol (IP) address
            and/or browser and device characteristics — is collected
            automatically when you visit our Services.
          </i>
          <div></div>
        </p>

        <p className="MsoNormal">
          We automatically collect certain information when you visit, use, or
          navigate the Services. This information does not reveal your specific
          identity (like your name or contact information) but may include
          device and usage information, such as your IP address, browser and
          device characteristics, operating system, language preferences,
          referring URLs, device name, country, location, information about how
          and when you use our Services, and other technical information. This
          information is primarily needed to maintain the security and operation
          of our Services, and for our internal analytics and reporting
          purposes.<div></div>
        </p>

        <p className="MsoNormal">
          Like many businesses, we also collect information through cookies and
          similar technologies.<div></div>
        </p>

        <p className="MsoNormal">
          The information we collect includes:<div></div>
        </p>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            <i>Log and Usage Data.</i>&nbsp;Log and usage data is
            service-related, diagnostic, usage, and performance information our
            servers automatically collect when you access or use our Services
            and which we record in log files. Depending on how you interact with
            us, this log data may include your IP address, device information,
            browser type, and settings and information about your activity in
            the Services&nbsp;(such as the date/time stamps associated with your
            usage, pages and files viewed, searches, and other actions you take
            such as which features you use), device event information (such as
            system activity, error reports (sometimes called&nbsp;&quot;crash
            dumps&quot;), and hardware settings).<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            <i>Device Data.</i>&nbsp;We collect device data such as information
            about your computer, phone, tablet, or other device you use to
            access the Services. Depending on the device used, this device data
            may include information such as your IP address (or proxy server),
            device and application identification numbers, location, browser
            type, hardware model, Internet service provider and/or mobile
            carrier, operating system, and system configuration information.
            <div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            <i>Location Data.</i>&nbsp;We collect location data such as
            information about your device's location, which can be either
            precise or imprecise. How much information we collect depends on the
            type and settings of the device you use to access the Services. For
            example, we may use GPS and other technologies to collect
            geolocation data that tells us your current location (based on your
            IP address). You can opt out of allowing us to collect this
            information either by refusing access to the information or by
            disabling your Location setting on your device. However, if you
            choose to opt out, you may not be able to use certain aspects of the
            Services.<div></div>
          </li>
        </ul>

        <p className="MsoNormal">
          <b>
            Google API<div></div>
          </b>
        </p>

        <p className="MsoNormal">
          Our use of information received from Google APIs will adhere to&nbsp;
          Google API Services User Data Policy , including the&nbsp; Limited Use
          requirements .
          <br />
          <div></div>
        </p>

        <p className="MsoNormal">
          <br />
          <div></div>
        </p>

        <p className="MsoNormal">
          <b>
            2. HOW DO WE PROCESS YOUR INFORMATION?<div></div>
          </b>
        </p>

        <p className="MsoNormal">
          <b>
            <i>In Short:&nbsp;</i>
          </b>
          <i>
            We process your information to provide, improve, and administer our
            Services, communicate with you, for security and fraud prevention,
            and to comply with law. We may also process your information for
            other purposes with your consent.
          </i>
          <div></div>
        </p>

        <p className="MsoNormal">
          <b>
            We process your personal information for a variety of reasons,
            depending on how you interact with our Services, including:
          </b>
          <div></div>
        </p>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            <b>
              To facilitate account creation and authentication and otherwise
              manage user accounts.&nbsp;
            </b>
            We may process your information so you can create and log in to your
            account, as well as keep your account in working order.<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            <b>
              To deliver and facilitate delivery of services to the user.&nbsp;
            </b>
            We may process your information to provide you with the requested
            service.<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            <b>To send administrative information to you.&nbsp;</b>We may
            process your information to send you details about our products and
            services, changes to our terms and policies, and other similar
            information.
            <div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            <b>To request feedback.&nbsp;</b>We may process your information
            when necessary to request feedback and to contact you about your use
            of our Services.<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            <b>To send you marketing and promotional communications.&nbsp;</b>We
            may process the personal information you send to us for our
            marketing purposes, if this is in accordance with your marketing
            preferences. You can opt out of our marketing emails at any time.
            For more information, see&nbsp;&quot; WHAT ARE YOUR PRIVACY RIGHTS?
            &quot;&nbsp;below.<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            <b>To protect our Services.</b>&nbsp;We may process your information
            as part of our efforts to keep our Services safe and secure,
            including fraud monitoring and prevention.<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            <b>To administer prize draws and competitions.</b>&nbsp;We may
            process your information to administer prize draws and competitions.
            <div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            <b>
              To evaluate and improve our Services, products, marketing, and
              your experience.
            </b>
            &nbsp;We may process your information when we believe it is
            necessary to identify usage trends, determine the effectiveness of
            our promotional campaigns, and to evaluate and improve our Services,
            products, marketing, and your experience.<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            <b>
              To determine the effectiveness of our marketing and promotional
              campaigns.
            </b>
            &nbsp;We may process your information to better understand how to
            provide marketing and promotional campaigns that are most relevant
            to you.<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            <b>To comply with our legal obligations.</b>&nbsp;We may process
            your information to comply with our legal obligations, respond to
            legal requests, and exercise, establish, or defend our legal rights.
            <div></div>
          </li>
        </ul>

        <p className="MsoNormal">
          <b>
            3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR INFORMATION?
            <div></div>
          </b>
        </p>

        <p className="MsoNormal">
          <b>
            <i>In Short:&nbsp;</i>
          </b>
          <i>
            We only process your personal information when we believe it is
            necessary and we have a valid legal reason (i.e.,&nbsp;legal basis)
            to do so under applicable law, like with your consent, to comply
            with laws, to provide you with services to enter into or&nbsp;
            <span className="SpellE">fulfill</span>&nbsp;our contractual
            obligations, to protect your rights, or to&nbsp;
            <span className="SpellE">fulfill</span>&nbsp;our legitimate business
            interests.
          </i>
          <div></div>
        </p>

        <p className="MsoNormal">
          We may process your information if you have given us specific
          permission (i.e.,&nbsp;express consent) to use your personal
          information for a specific purpose, or in situations where your
          permission can be inferred (i.e.,&nbsp;implied consent). You can&nbsp;
          withdraw your consent &nbsp;at any time.<div></div>
        </p>

        <p className="MsoNormal">
          In some exceptional cases, we may be legally permitted under
          applicable law to process your information without your consent,
          including, for example:<div></div>
        </p>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            If collection is clearly in the interests of an individual and
            consent cannot be obtained in a timely way<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            For investigations and fraud detection and prevention<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            For business transactions provided certain conditions are met
            <div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            If it is contained in a witness statement and the collection is
            necessary to assess, process, or settle an insurance claim
            <div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            For identifying injured, ill, or deceased persons and communicating
            with next of kin<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            If we have reasonable grounds to believe an individual has been, is,
            or may be victim of financial abuse<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            If it is reasonable to expect collection and use with consent would
            compromise the availability or the accuracy of the information and
            the collection is reasonable for purposes related to investigating a
            breach of an agreement or a contravention of the laws of Canada or a
            province<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            If disclosure is required to comply with a subpoena, warrant, court
            order, or rules of the court relating to the production of records
            <div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            If it was produced by an individual in the course of their
            employment, business, or profession and the collection is consistent
            with the purposes for which the information was produced<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            If the collection is solely for journalistic, artistic, or literary
            purposes<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            If the information is publicly available and is specified by the
            regulations<div></div>
          </li>
        </ul>

        <p className="MsoNormal">
          <b>
            4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
            <div></div>
          </b>
        </p>

        <p className="MsoNormal">
          <b>
            <i>In Short:</i>
          </b>
          <i>
            &nbsp;We may share information in specific situations described in
            this section and/or with the following&nbsp;third parties.
          </i>
          <div></div>
        </p>

        <p className="MsoNormal">
          We&nbsp;may need to share your personal information in the following
          situations:<div></div>
        </p>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            <b>Business Transfers.</b>&nbsp;We may share or transfer your
            information in connection with, or during negotiations of, any
            merger, sale of company assets, financing, or acquisition of all or
            a portion of our business to another company.<div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            <b>When we use Google Maps Platform APIs.</b>&nbsp;We may share your
            information with certain Google Maps Platform APIs
            (e.g.,&nbsp;Google Maps API, Places API).&nbsp;Google Maps uses GPS,
            Wi-Fi, and cell towers to estimate your location. GPS is accurate to
            about 20 meters, while Wi-Fi and cell towers help improve accuracy
            when GPS signals are weak, like indoors. This data helps Google Maps
            provide directions, but it is not always perfectly precise.
            <div></div>
          </li>
        </ul>

        <p className="MsoNormal">
          <b>
            5. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?<div></div>
          </b>
        </p>

        <p className="MsoNormal">
          <b>
            <i>In Short:</i>
          </b>
          <i>
            &nbsp;We may use cookies and other tracking technologies to collect
            and store your information.
          </i>
          <div></div>
        </p>

        <p className="MsoNormal">
          We may use cookies and similar tracking technologies (like web beacons
          and pixels) to gather information when you interact with our Services.
          Some online tracking technologies help us maintain the security of our
          Services&nbsp;and your account, prevent crashes, fix bugs, save your
          preferences, and assist with basic site functions.<div></div>
        </p>

        <p className="MsoNormal">
          We also permit third parties and service providers to use online
          tracking technologies on our Services for analytics and advertising,
          including to help manage and display advertisements, to tailor
          advertisements to your interests, or to send abandoned shopping cart
          reminders (depending on your communication preferences). The third
          parties and service providers use their technology to provide
          advertising about products and services tailored to your interests
          which may appear either on our Services or on other websites.
          <div></div>
        </p>

        <p className="MsoNormal">
          Specific information about how we use such technologies and how you
          can refuse certain cookies is set out in our Cookie Notice.
          <b>
            <div></div>
          </b>
        </p>

        <p className="MsoNormal">
          <b>
            Google Analytics<div></div>
          </b>
        </p>

        <p className="MsoNormal">
          We may share your information with Google Analytics to track and&nbsp;
          <span className="SpellE">analyze</span>&nbsp;the use of the
          Services.&nbsp;To opt out of being tracked by Google Analytics across
          the Services, visit&nbsp; https://tools.google.com/dlpage/gaoptout
          .&nbsp;For more information on the privacy practices of Google, please
          visit the&nbsp;
          <a href="https://policies.google.com/privacy" target="_blank">
            Google Privacy &amp; Terms page
          </a>
          .<div></div>
        </p>

        <p className="MsoNormal">
          <b>
            6. HOW DO WE HANDLE YOUR SOCIAL LOGINS?<div></div>
          </b>
        </p>

        <p className="MsoNormal">
          <b>
            <i>In Short:&nbsp;</i>
          </b>
          <i>
            If you choose to register or log in to our Services using a social
            media account, we may have access to certain information about you.
          </i>
          <div></div>
        </p>

        <p className="MsoNormal">
          Our Services offer you the ability to register and log in using your
          third-party social media account details (like your Facebook or X
          logins). Where you choose to do this, we will receive certain profile
          information about you from your social media provider. The profile
          information we receive may vary depending on the social media provider
          concerned, but will often include your name, email address, friends
          list, and profile picture, as well as other information you choose to
          make public on such a social media platform.<div></div>
        </p>

        <p className="MsoNormal">
          We will use the information we receive only for the purposes that are
          described in this Privacy Notice or that are otherwise made clear to
          you on the relevant Services. Please note that we do not control, and
          are not responsible for, other uses of your personal information by
          your third-party social media provider. We recommend that you review
          their privacy notice to understand how they collect, use, and share
          your personal information, and how you can set your privacy
          preferences on their sites and apps.<div></div>
        </p>

        <p className="MsoNormal">
          <b>
            7. HOW LONG DO WE KEEP YOUR INFORMATION?<div></div>
          </b>
        </p>

        <p className="MsoNormal">
          <b>
            <i>In Short:&nbsp;</i>
          </b>
          <i>
            We keep your information for as long as necessary to&nbsp;
            <span className="SpellE">fulfill</span>&nbsp;the purposes outlined
            in this Privacy Notice unless otherwise required by law.
          </i>
          <div></div>
        </p>

        <p className="MsoNormal">
          We will only keep your personal information for as long as it is
          necessary for the purposes set out in this Privacy Notice, unless a
          longer retention period is required or permitted by law (such as tax,
          accounting, or other legal requirements).&nbsp;No purpose in this
          notice will require us keeping your personal information for longer
          than&nbsp;the period of time in which users have an account with us.
          <div></div>
        </p>

        <p className="MsoNormal">
          When we have no ongoing legitimate business need to process your
          personal information, we will either delete
          or&nbsp;anonymize&nbsp;such information, or, if this is not possible
          (for example, because your personal information has been stored in
          backup archives), then we will securely store your personal
          information and isolate it from any further processing until deletion
          is possible.<div></div>
        </p>

        <p className="MsoNormal">
          <b>
            8. HOW DO WE KEEP YOUR INFORMATION SAFE?<div></div>
          </b>
        </p>

        <p className="MsoNormal">
          <b>
            <i>In Short:&nbsp;</i>
          </b>
          <i>
            We aim to protect your personal information through a system
            of&nbsp;organizational&nbsp;and technical security measures.
          </i>
          <div></div>
        </p>

        <p className="MsoNormal">
          We have implemented appropriate and reasonable technical
          and&nbsp;organizational&nbsp;security measures designed to protect the
          security of any personal information we process. However, despite our
          safeguards and efforts to secure your information, no electronic
          transmission over the Internet or information storage technology can
          be guaranteed to be 100% secure, so we cannot promise or guarantee
          that hackers, cybercriminals, or other&nbsp;unauthorized&nbsp;third
          parties will not be able to defeat our security and improperly
          collect, access, steal, or modify your information. Although we will
          do our best to protect your personal information, transmission of
          personal information to and from our Services is at your own risk. You
          should only access the Services within a secure environment.
          <div></div>
        </p>

        <p className="MsoNormal">
          <b>
            9. WHAT ARE YOUR PRIVACY RIGHTS?<div></div>
          </b>
        </p>

        <p className="MsoNormal">
          <b>
            <i>In Short:</i>
          </b>
          <i>
            &nbsp;In&nbsp;some regions, such as&nbsp;Canada, you have rights
            that allow you greater access to and control over your personal
            information.&nbsp;You may review, change, or terminate your account
            at any time, depending on your country, province, or state of
            residence.
          </i>
          <div></div>
        </p>

        <p className="MsoNormal">
          In some regions (like&nbsp;Canada), you have certain rights under
          applicable data protection laws. These may include the right (
          <span className="SpellE">i</span>) to request access and obtain a copy
          of your personal information, (ii) to request rectification or
          erasure; (iii) to restrict the processing of your personal
          information; (iv) if applicable, to data portability; and (v) not to
          be subject to automated decision-making. In certain circumstances, you
          may also have the right to object to the processing of your personal
          information. You can make such a request by contacting us by using the
          contact details provided in the section&nbsp;&quot; HOW CAN YOU
          CONTACT US ABOUT THIS NOTICE? &quot;&nbsp;below.<div></div>
        </p>

        <p className="MsoNormal">
          We will consider and act upon any request in accordance with
          applicable data protection laws.<div></div>
        </p>

        <p className="MsoNormal">
          <b>
            <u>Withdrawing your consent:</u>
          </b>
          &nbsp;If we are relying on your consent to process your personal
          information,&nbsp;which may be express and/or implied consent
          depending on the applicable law,&nbsp;you have the right to withdraw
          your consent at any time. You can withdraw your consent at any time by
          contacting us by using the contact details provided in the
          section&nbsp;&quot; HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
          &quot;&nbsp;below.<div></div>
        </p>

        <p className="MsoNormal">
          However, please note that this will not affect the lawfulness of the
          processing before its withdrawal nor,&nbsp;when applicable law
          allows,&nbsp;will it affect the processing of your personal
          information conducted in reliance on lawful processing grounds other
          than consent.
          <div></div>
        </p>

        <p className="MsoNormal">
          <b>
            <u>Opting out of marketing and promotional communications:</u>&nbsp;
          </b>
          You can unsubscribe from our marketing and promotional communications
          at any time by&nbsp;clicking on the unsubscribe link in the emails
          that we send,&nbsp;replying&nbsp;&quot;STOP&quot; or
          &quot;UNSUBSCRIBE&quot;&nbsp;to the SMS messages that we send,&nbsp;or
          by contacting us using the details provided in the section&nbsp;&quot;
          HOW CAN YOU CONTACT US ABOUT THIS NOTICE? &quot;&nbsp;below. You will
          then be removed from the marketing lists. However, we may still
          communicate with you — for example, to send you service-related
          messages that are necessary for the administration and use of your
          account, to respond to service requests, or for other non-marketing
          purposes.
          <b>
            <div></div>
          </b>
        </p>

        <p className="MsoNormal">
          <b>
            Account Information<div></div>
          </b>
        </p>

        <p className="MsoNormal">
          If you would at any time like to review or change the information in
          your account or terminate your account, you can:<div></div>
        </p>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            Log in to your account settings and update your user account.
            <div></div>
          </li>
        </ul>

        <ul style={{ marginTop: "0in" }} type="disc">
          <li
            className="MsoNormal"
            style={{ listStyleType: "none", tabStops: "list .5in" }}
          >
            Contact us using the contact information provided.<div></div>
          </li>
        </ul>

        <p className="MsoNormal">
          Upon your request to terminate your account, we will deactivate or
          delete your account and information from our active databases.
          However, we may retain some information in our files to prevent fraud,
          troubleshoot problems, assist with any investigations, enforce our
          legal terms and/or comply with applicable legal requirements.
          <div></div>
        </p>

        <p className="MsoNormal">
          <b>
            <u>Cookies and similar technologies:</u>
          </b>
          &nbsp;Most Web browsers are set to accept cookies by default. If you
          prefer, you can usually choose to set your browser to remove cookies
          and to reject cookies. If you choose to remove cookies or reject
          cookies, this could affect certain features or services of our
          Services.
          <div></div>
        </p>

        <p className="MsoNormal">
          If you have questions or comments about your privacy rights, you may
          email us at&nbsp;admin@newlifefinancialservices.ca.<div></div>
        </p>

        <p className="MsoNormal">
          <b>
            10. CONTROLS FOR DO-NOT-TRACK FEATURES<div></div>
          </b>
        </p>

        <p className="MsoNormal">
          Most web browsers and some mobile operating systems and mobile
          applications include a Do-Not-Track (&quot;DNT&quot;) feature or
          setting you can activate to signal your privacy preference not to have
          data about your online browsing activities monitored and collected. At
          this stage, no uniform technology standard
          for&nbsp;recognizing&nbsp;and implementing DNT signals has
          been&nbsp;finalized. As such, we do not currently respond to DNT
          browser signals or any other mechanism that automatically communicates
          your choice not to be tracked online. If a standard for online
          tracking is adopted that we must follow in the future, we will inform
          you about that practice in a revised version of this Privacy Notice.
          <div></div>
        </p>

        <p className="MsoNormal">
          <b>
            11. DO WE MAKE UPDATES TO THIS NOTICE?<div></div>
          </b>
        </p>

        <p className="MsoNormal">
          <b>
            <i>In Short:&nbsp;</i>
          </b>
          <i>
            Yes, we will update this notice as necessary to stay compliant with
            relevant laws.
          </i>
          <div></div>
        </p>

        <p className="MsoNormal">
          We may update this Privacy Notice from time to time. The updated
          version will be indicated by an
          updated&nbsp;&quot;Revised&quot;&nbsp;date at the top of this Privacy
          Notice. If we make material changes to this Privacy Notice, we may
          notify you either by prominently posting a notice of such changes or
          by directly sending you a notification. We encourage you to review
          this Privacy Notice frequently to be informed of how we are protecting
          your information.<div></div>
        </p>

        <p className="MsoNormal">
          <b>
            12. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?<div></div>
          </b>
        </p>

        <p className="MsoNormal">
          If you have questions or comments about this notice, you
          may&nbsp;email us at&nbsp;admin@newlifefinancialdervices.ca
          or&nbsp;contact us by post at:<div></div>
        </p>

        <p className="MsoNormal">
          New Life Financial Services Ltd.<div></div>
        </p>

        <p className="MsoNormal">
          9868A 33ave NW<div></div>
        </p>

        <p className="MsoNormal">
          Edmonton,&nbsp;Alberta&nbsp;T6N1C6<div></div>
        </p>

        <p className="MsoNormal">
          Canada<div></div>
        </p>

        <p className="MsoNormal">
          <b>
            13. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM
            YOU?<div></div>
          </b>
        </p>

        <p className="MsoNormal">
          Based on the applicable laws of your country, you may&nbsp;have the
          right to request access to the personal information we collect from
          you, details about how we have processed it, correct inaccuracies, or
          delete your personal information. You may also have the right
          to&nbsp;withdraw your consent to our processing of your personal
          information. These rights may be limited in some circumstances by
          applicable law. To request to review, update, or delete your personal
          information, please&nbsp;fill out and submit a&nbsp; data subject
          access request .<div></div>
        </p>
      </div>
    </div>
  );
}
